module.exports = __webpack_public_path__ + "img/las_vegas.dd061862.png";